import { faFilePdf } from "@fortawesome/fontawesome-free-solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

export default function CertificateCard({
  level,
  certUrl,
  paymentStatus,
  imgSrc,
}) {
  const bgColors = {
    1: "bg-green-100",
    2: "bg-sky-100",
    3: "bg-purple-100",
    4: "bg-yellow-100",
  };

  const btnColors = {
    1: "bg-green-500",
    2: "bg-blue-500",
    3: "bg-purple-500",
    4: "bg-yellow-500",
  };

  return (
    <div className={`text-center p-5 rounded w-fit ${bgColors[level]}`}>
      <img
        className="rounded"
        src={imgSrc}
        alt={`Level ${level} certificate`}
      />
      {paymentStatus === "due" ? (
        <Link
          className="bg-red-500 block mt-2 text-white p-2 rounded shadow"
          to="/tajweed-due"
        >
          বকেয়া পরিশোধ করুন
        </Link>
      ) : (
        <a
          className={`${btnColors[level]} block mt-2 text-white p-2 rounded shadow`}
          href={certUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon className="pr-5" icon={faFilePdf} />
          Level {level} Certificate
        </a>
      )}
    </div>
  );
}
